"use client";

import React from "react";
import { LogSnagProvider } from "@logsnag/next";

import PlausibleProvider from "next-plausible";

import { TRPCReactProvider } from "~/trpc/react";
import { env } from "~/env.mjs";

import { ThemeProvider } from "./theme-provider";
import { TooltipProvider } from "~/components/ui/tooltip";
import { SubscriptionProvider } from "~/hooks/user-subsciption";
import { UnsavedWarningPromptContextProvider } from "~/hooks/use-unsaved-changes-prompt";
import { MarketplaceOnboardingRedirectRecovery } from "~/components/marketplace/marketplace-onboarding-redirect-recovery";
import Script from "next/script";

const Providers = ({ children }: { children: React.ReactNode }) => {
  return (
    <ThemeProvider
      attribute="class"
      defaultTheme="light"
      enableSystem
      disableTransitionOnChange
    >
      <TRPCReactProvider>
        <PlausibleProvider
          scriptProps={{
            src: env.NEXT_PUBLIC_PLAUSIBLE_SELFHOSTED_URL,
          }}
          domain={env.NEXT_PUBLIC_DEPLOYMENT_URL.replace("https://", "")}
        >
          <LogSnagProvider
            token={
              env.NEXT_PUBLIC_LOGSNAG_DISABLE_TRACKING === "1"
                ? ""
                : env.NEXT_PUBLIC_LOGSNAG_TOKEN
            }
            project={env.NEXT_PUBLIC_LOGSNAG_PROJECT}
          />
          <Script
            src="https://cdn.tolt.io/tolt.js"
            data-tolt="b249d58e-6860-44b2-8bcc-dd670cb41969"
          />
          <TooltipProvider>
            <SubscriptionProvider>
              <UnsavedWarningPromptContextProvider>
                <MarketplaceOnboardingRedirectRecovery />
                {children}
              </UnsavedWarningPromptContextProvider>
            </SubscriptionProvider>
          </TooltipProvider>
        </PlausibleProvider>
      </TRPCReactProvider>
    </ThemeProvider>
  );
};

export default Providers;
